// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Bvek","alertIcon":"ConfirmModal_alertIcon__1YKzy"};